import React, { useContext, useEffect, useMemo } from 'react';
import { StudioContext } from '@home/pages/studio/context';
import { buriedPointGame } from '@home/utils/buriedPoint';
import { PageLogMes } from '@home/utils/buriedPointCfg';
import OpinionsStudio from './OpinionsStudio';
import { useIntl } from 'umi';
import { ConfigProvider } from 'tea-component';
import StudioState from '../components/StudioState';

export default function Competitor() {
  const { currentGame, menuPermission } = useContext(StudioContext);
  const { locale } = useIntl();
  const gameInfo = useMemo(() => {
    const {
      unified_edition_id: edition_unified_id,
      id_type,
      game_type: entity_type,
    } = currentGame || {};
    return {
      edition_unified_id,
      id_type,
      entity_type,
    };
  }, [currentGame]);

  useEffect(() => {
    const { unified_edition_id: gameid } =
      currentGame || {};

    buriedPointGame({gameName: currentGame?.game_name, ...PageLogMes.studioOpinion}, gameid, 'unified_id');
  }, [currentGame]);

  useEffect(() => {
    // 设置全局样式
    const element = document.querySelector('.dbh-studio-context');
    if (element && menuPermission === true) {
      (element as HTMLElement).style.backgroundColor = '#ebecf1';
    }
    return () => {
      // 去掉全局样式
      if (element) {
        (element as HTMLElement).style.backgroundColor = '#fff';
      }
    };
  }, [menuPermission]);
  
  if (menuPermission === false) {
    return <StudioState isNoPermission={true} />;
  }
  return <ConfigProvider locale={locale === 'zh-CN' ? 'zh' : "en"}>
    <OpinionsStudio gameInfo={gameInfo} />
  </ConfigProvider>;
}
